import React from 'react';
import { FacebookIcon, InstagramIcon, BookOpenIcon, UsersIcon, ArrowRightIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Logo } from './Logo';
import { useTheme } from '../context/ThemeContext';
export function HeroSection() {
  const {
    theme
  } = useTheme();
  return <main className="w-full px-4 sm:px-6 md:px-10 lg:px-20 py-10 sm:py-16 md:py-24" data-id="element-554">
      <div className="max-w-7xl mx-auto" data-id="element-555">
        <div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-10 lg:gap-12" data-id="element-556">
          {/* Left Column */}
          <div className="flex-1 space-y-6 sm:space-y-8" data-id="element-557">
            <div className="inline-flex items-center px-3 py-1.5 sm:px-4 sm:py-2 bg-blue-100/50 dark:bg-blue-900/50 rounded-full text-blue-600 dark:text-blue-400 text-xs sm:text-sm font-medium backdrop-blur-sm" data-id="element-558">
              <BookOpenIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 sm:mr-2" data-id="element-559" />
              Start Learning English Today
              <ArrowRightIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 ml-1.5 sm:ml-2" data-id="element-560" />
            </div>
            <div className="space-y-4 sm:space-y-6" data-id="element-561">
              <div className="flex items-center gap-3" data-id="element-562">
                <Logo width={48} height={48} color={theme === 'dark' ? '#60A5FA' : '#3B82F6'} data-id="element-563" />
                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight" data-id="element-564">
                  <span className="text-blue-600 dark:text-blue-400" data-id="element-565">
                    Arabic
                  </span>
                  <span className="text-gray-900 dark:text-white" data-id="element-566">
                    withenglish
                  </span>
                </h1>
              </div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight" data-id="element-567">
                <span className="block text-gray-900 dark:text-white" data-id="element-568">
                  Master English
                </span>
                <span className="block text-blue-600 dark:text-blue-400 mt-1 sm:mt-2" dir="rtl" data-id="element-569">
                  إتقان اللغة الإنجليزية
                </span>
              </h2>
              <div className="space-y-3 sm:space-y-4 max-w-xl" data-id="element-570">
                <p className="text-base sm:text-lg md:text-xl text-gray-600 dark:text-gray-300" data-id="element-571">
                  Transform your English skills through Arabic-guided learning,
                  interactive lessons, and a supportive community.
                </p>
                <p className="text-base sm:text-lg md:text-xl text-gray-600 dark:text-gray-300 text-right" dir="rtl" data-id="element-572">
                  طور مهاراتك في اللغة الإنجليزية من خلال التعلم الموجه باللغة
                  العربية
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4" data-id="element-573">
                <a href="https://www.facebook.com/profile.php?id=61552531610209&ref=ig_profile_ac" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-574">
                  <CTAButton icon={<FacebookIcon className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-576" />} text="Join Community" primary={true} data-id="element-575" />
                </a>
                <a href="https://www.instagram.com/arabicwithenglish/" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-577">
                  <CTAButton icon={<InstagramIcon className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-579" />} text="Follow Updates" primary={false} data-id="element-578" />
                </a>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 md:gap-8 pt-6 sm:pt-8 border-t border-gray-200 dark:border-gray-700" data-id="element-580">
              <div className="flex items-center gap-2" data-id="element-581">
                <div className="p-1.5 sm:p-2 bg-blue-100/50 dark:bg-blue-900/50 rounded-lg" data-id="element-582">
                  <UsersIcon className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 dark:text-blue-400" data-id="element-583" />
                </div>
                <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-300" data-id="element-584">
                  <span className="block font-medium text-gray-900 dark:text-white" data-id="element-585">
                    5,000+
                  </span>
                  Active Students
                </div>
              </div>
              <div className="flex items-center gap-2" data-id="element-586">
                <div className="p-1.5 sm:p-2 bg-blue-100/50 dark:bg-blue-900/50 rounded-lg" data-id="element-587">
                  <Logo width={20} height={20} color={theme === 'dark' ? '#60A5FA' : '#3B82F6'} data-id="element-588" />
                </div>
                <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-300" data-id="element-589">
                  <span className="block font-medium text-gray-900 dark:text-white" data-id="element-590">
                    15+
                  </span>
                  Arab Countries
                </div>
              </div>
            </div>
          </div>
          {/* Right Column */}
          <div className="flex-1 relative w-full mt-6 lg:mt-0 px-2 sm:px-0" data-id="element-591">
            <div className="relative" data-id="element-592">
              <div className="absolute -top-3 sm:-top-4 -left-3 sm:-left-4 bg-white dark:bg-gray-800 rounded-lg p-3 sm:p-4 shadow-lg dark:shadow-gray-900/50 z-10 animate-float-slow" data-id="element-593">
                <p className="text-base sm:text-lg font-medium text-gray-900 dark:text-white" data-id="element-594">
                  Hello! مرحباً
                </p>
              </div>
              <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl sm:shadow-2xl dark:shadow-gray-900/50 overflow-hidden" data-id="element-595">
                <div className="relative" data-id="element-596">
                  <img src="https://images.unsplash.com/photo-1571260899304-425eee4c7efc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Students in a modern learning environment" className="w-full h-40 sm:h-48 object-cover" data-id="element-597" />
                  <div className="absolute top-2 right-2 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm p-1 rounded-lg" data-id="element-598">
                    <Logo width={24} height={24} color={theme === 'dark' ? '#60A5FA' : '#3B82F6'} data-id="element-599" />
                  </div>
                </div>
                <div className="p-4 sm:p-6" data-id="element-600">
                  <h3 className="font-semibold text-base sm:text-lg mb-3 sm:mb-4 text-gray-900 dark:text-white" data-id="element-601">
                    Today's Words
                  </h3>
                  <div className="space-y-2 sm:space-y-3" data-id="element-602">
                    {[{
                    en: 'Success',
                    ar: 'النجاح'
                  }, {
                    en: 'Confidence',
                    ar: 'الثقة'
                  }, {
                    en: 'Progress',
                    ar: 'التقدم'
                  }].map((word, i) => <div key={i} className="flex items-center justify-between p-1.5 sm:p-2 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/30 transition-colors" data-id="element-603">
                        <span className="font-medium text-sm sm:text-base text-gray-900 dark:text-white" data-id="element-604">
                          {word.en}
                        </span>
                        <span className="text-sm sm:text-base text-blue-600 dark:text-blue-400" dir="rtl" data-id="element-605">
                          {word.ar}
                        </span>
                      </div>)}
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-3 sm:-bottom-4 -right-3 sm:-right-4 bg-yellow-50 dark:bg-yellow-900/30 rounded-lg p-3 sm:p-4 shadow-lg dark:shadow-gray-900/50 animate-float" data-id="element-606">
                <p className="text-base sm:text-lg font-medium text-gray-900 dark:text-white" data-id="element-607">
                  Thank you! شكراً
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>;
}